//show alert function
function clv_alertMsg(msg){
	//RetroCompatibilita' sulle chiamate del clv_alertMsg
	clv_showAlert(msg, 'alert-danger');
}
// JavaScript Document
function clv_alertMsg2(msg){
	//myApp.showMyAlert(msg);	
	showMyAlert(msg);
}
var isMobile = true; //initiate as false //bloccato a true per disabilitare il blocco al selettore tratte
var presetArray = [];

jQuery(document).ready(function(e) {
	/*
	try{
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;
	}catch(ex){}
	*/
	
	/*
	jQuery( "#btn_submitLogin" ).click(function(e){
		clv_login();
	});
	*/
/*	
	jQuery( "#btn_logout" ).click(function(e){
		jQuery("#logout-form").submit();
	});
*/
	jQuery(".searchticket-fom [name=start]").change(function(e){
		var idStart = jQuery(this).val();//# + id del select partenze
		if (idStart == ""){ clv_alertMsg2("Seleziona una partenza.");return; }
		if (!isMobile){
			jQuery(this).prop( "disabled", true );
			jQuery(".searchticket-fom [name=end]").prop( "disabled", true );
		}
		jQuery(".searchticket-fom [name=start]").val(idStart);
		clv_getDestinazioni(idStart);
	});

	jQuery(".searchticket-fom [name=end]").change(function(e){
		var idEnd = jQuery(this).val();
		jQuery(".searchticket-fom [name=end]").val(idEnd);
	});

	jQuery(".reservation-form [name=start]").change(function(e){
		var specialMode = jQuery(".reservation-form [name=specialMode]").val();
		var idStart = jQuery(this).val();//# + id del select partenze
		if (idStart == ""){ clv_alertMsg2("Seleziona una partenza.");return; }
		if (!isMobile){
			jQuery(this).prop( "disabled", true );
			jQuery(".reservation-form [name=end]").prop( "disabled", true );
		}
		jQuery(".reservation-form [name=start]").val(idStart);
		clv_getDestinazioni_prenotazione(idStart, specialMode);
	});

	jQuery(".reservation-form [name=end]").change(function(e){
		var idEnd = jQuery(this).val();
		jQuery(".reservation-form [name=end]").val(idEnd);
	});

	
	if (jQuery('input[type=radio][name=ar]:checked').val() == "false")
		jQuery("input[name=dataRitorno]").hide();//.prop('disabled', true);
	else jQuery("input[name=dataRitorno]").show();
	
	//console.log("val:"+jQuery('input[type=radio][name=ar]').val());
	jQuery('input[type=radio][name=ar]').change(function() {
		//console.log(this.value);
        if (this.value == 'true') {
            jQuery("input[name=dataRitorno]").show();
        }
        else if (this.value == 'false') {
            jQuery("input[name=dataRitorno]").hide();
        }
    });
	
	jQuery( "#formSearchDatetimeOut" ).datepicker({ minDate: 0 });//, maxDate: "+1M +10D"
	jQuery( "#formSearchDatetimeBack" ).datepicker({ minDate: 0 });
	
	jQuery( "#formSearchDatetimeOut" ).change(function(e){
		clv_verifica_campoData(this);
		
		var ar = jQuery("input[type=radio][name=ar]:checked").val();
		console.log(ar);
		if(ar=="false") return;
		
		if(this.value == "") return;
		var v1 = this.value;
		var v2 = jQuery( "#formSearchDatetimeBack" ).val();
		if(v2 == ""){
			 jQuery( "#formSearchDatetimeBack" ).val(this.value);
			 return;
		}
		var dStart = clv_stringToDate(v1);
		var dEnd = clv_stringToDate(v2);
		if (dEnd < dStart) jQuery( "#formSearchDatetimeBack" ).val(clv_dateToString(dStart));
	});
	
	jQuery( "#formSearchDatetimeBack" ).change(function(e){
		clv_verifica_campoData(this);
		
		if(this.value == "") return;
		var v2 = this.value;
		var v1 = jQuery( "#formSearchDatetimeOut" ).val();
		if(v1 == "") return;
		var dStart = clv_stringToDate(v1);
		var dEnd = clv_stringToDate(v2);
		if (dEnd < dStart) this.value = clv_dateToString(dStart);

	});


	jQuery('#ticket-form').submit(function(e){
		if (jQuery('select[name=start]').val()== ""){
			clv_alertMsg2("devi selezionare una partenza.");
			e.preventDefault(e);
			return false;
		}
		if (jQuery('select[name=end]').val()== ""){
			clv_alertMsg2("devi selezionare una destinazione.");
			e.preventDefault(e);
			return false;
		}
		if (jQuery('[name=qt]').val()== ""){
			clv_alertMsg2("devi selezionare ilnumero di passeggeri.");
			e.preventDefault(e);
			return false;
		}

        var v1 = jQuery('#formSearchDatetimeOut').val();
        if(! clv_isDate(v1)){
			 clv_alertMsg2("Data di partenza non valida.");
			 e.preventDefault(e);
			 return false;
		}
		var ar = jQuery("input[type=radio][name=ar]:checked").val();
		var v2 = jQuery('#formSearchDatetimeBack').val();
		if(ar=="true") {
			if(! clv_isDate(v2)){
				clv_alertMsg2("Data di ritorno non valida.");
				e.preventDefault(e);
				return false;
			}
		}
		//jQuery(this).submit();
		return true;
    });
	
	
});

function clv_verifica_campoData(obj){

	if (!clv_isDate(obj.value)){
		this.value = "";
		return;
	}
	
	var v1 = clv_stringToDate(obj.value);
	var oggi = clv_oggi();
	console.log(v1);
	console.log("oggi:"+oggi);
	if (v1.getTime()  < oggi.getTime() )
		obj.value = clv_dateToString(oggi);
}

function clv_oggi(){
	
	var date = new Date();
	var day = date.getDate();
	var month = date.getMonth();
	var year = date.getFullYear();
	return new Date(year,month,day);
}
// input dd/mm/yyyy
function clv_stringToDate(txtDate)
{

  var dtArray = txtDate.split("/"); 

  if (dtArray == null)
     return false;
 
  //Checks for dd/mm/yyyy format.
  dtMonth = dtArray[1]-1;
  dtDay= dtArray[0];
  dtYear = dtArray[2];
  return new Date(dtYear,dtMonth,dtDay);
}

function clv_dateToString(date)
{
	var day = date.getDate();
	var month = date.getMonth()+1;//va da 0..11, facciamo +1
	var year = date.getFullYear();
	return day+"/"+month+"/"+year;
}


function clv_isDate(txtDate)
{
  var currVal = txtDate;
  if(currVal == '')
    return false;
  
  //Declare Regex  
  var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; 
  var dtArray = currVal.match(rxDatePattern); // is format OK?

  if (dtArray == null)
     return false;
 
  //Checks for dd/mm/yyyy format.
  dtMonth = dtArray[3];
  dtDay= dtArray[1];
  dtYear = dtArray[5];

  if (dtMonth < 1 || dtMonth > 12)
      return false;
  else if (dtDay < 1 || dtDay> 31)
      return false;
  else if ((dtMonth==4 || dtMonth==6 || dtMonth==9 || dtMonth==11) && dtDay ==31)
      return false;
  else if (dtMonth == 2)
  {
     var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
     if (dtDay> 29 || (dtDay ==29 && !isleap))
          return false;
  }
  return true;
}


//https://jquery-ui.googlecode.com/svn-history/r3982/trunk/ui/i18n/
/* Italian ed UK (cambia di sicuro il formato della data) initialisation for the jQuery UI date picker plugin. */
/* Written by Antonello Pasella (antonello.pasella@gmail.com). */
jQuery(function($){
	$.datepicker.regional['it'] = {
		closeText: 'Chiudi',
		prevText: '&#x3c;Prec',
		nextText: 'Succ&#x3e;',
		currentText: 'Oggi',
		monthNames: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
			'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
		monthNamesShort: ['Gen','Feb','Mar','Apr','Mag','Giu',
			'Lug','Ago','Set','Ott','Nov','Dic'],
		dayNames: ['Domenica','Luned&#236','Marted&#236','Mercoled&#236','Gioved&#236','Venerd&#236','Sabato'],
		dayNamesShort: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],
		dayNamesMin: ['Do','Lu','Ma','Me','Gi','Ve','Sa'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
		
	$.datepicker.regional['en'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['January','February','March','April','May','June',
		'July','August','September','October','November','December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	
	jQuery.datepicker.setDefaults(jQuery.datepicker.regional['it']);
	//jQuery.datepicker.setDefaults(jQuery.datepicker.regional['en']);
});


/****************************************************************************/
var urlTicketing = gaspariURL.ROOT_URL_API;
/* Il login viene gestito in submit, con PHP */
/*function clv_login() {
	//NOTA: il file ashx da caricare, lo parametriziamo per gestire anche le chiamate per le altre funzioni, come login, etc... che usano altri ashx
	var url = urlTicketing + "ashx/utenti_exec.ashx";//nota: urlTicketing definita globalmente in JS
	var mode = 'login';
	var mydata = "mode: '" + mode + "'";
	
	var v1 = jQuery("#username").val();//# + id del select partenze
	var v2 = jQuery("#password").val();//# + id del select partenze
	if (v1 == "") return;
	
	jQuery("#login-form").submit();
	//mydata += ", username:'"+ v1 + "', password:'"+ password +"' ";
	//callbackFunc = "callback_getDestinazioni";
	
	//clv_ajax_call(mode,url,mydata);
}
*/

//al ritorno, chiama la funzione di callback del "mode", se esiste: clv_callback_valoreMode();
function clv_ajax_call(mode, url, mydata) {
	var action = "clv_getUrlResponse";
	jQuery.post(
			ajaxurl, 
			{
				'action': action,
				'url': url, //'<?= ROOT_URL_API.ASHX_DISPONIBILITA ?>',
				'data':mydata
			}, 
			function(response){
				try {
					res = jQuery.parseJSON(response || null);
					//console.log(res.response);
					if (res == null) {//problema parsing json della stringa di ritorno
						hidePleaseWait();
						clv_alertMsg2("Si è verificato un problema. Ritorno nullo.");
						return;
					}
					if (res.response == "ok") {//ok
						//console.log(res.data);
						//clv_callbacks(mode,res.data);
						//chiama la funzione di callback del "mode", se esiste
						mode = mode.replace(/-/g ,'_');
						console.log('mode:' + mode);
						if (typeof eval("clv_callback_"+mode) == 'function') { 
						  eval("clv_callback_"+mode+"(res);");
						}
					}
					else {//problema, response == "ko"
						hidePleaseWait();
						clv_alertMsg2(res.data);
					}
				} catch (e) {
					console.log(e);
					hidePleaseWait();
					clv_alertMsg2("Si è verificato un problema. Ritorno non valido.");
				}
			});
}
/* sostituita da clv_alertMsg
function clv_showError(messaggio){
	alert(messaggio);
	//jQuery("#" + responseAreaId).html("Si &egrave; verificato un problema.");
}
*/
function clv_getDestinazioni(idStart) {
	//NOTA: il file ashx da caricare, lo parametriziamo per gestire anche le chiamate per le altre funzioni, come login, etc... che usano altri ashx
	if (idStart == "") return;
	// if (typeof(destinazioniBooking) === 'undefined'){
	if (true){
		var url = urlTicketing + gaspariURL.ASHX_BOOKING;//nota: urlTicketing definita globalmente in JS
		var mode = 'getDestinazioni';
		var mydata = "{" +"mode: '" + mode + "'";
		
		mydata += ", id:'"+ idStart + "'" + "}";
		var action = "clv_getUrlResponse";
		clv_ajax_call(mode, url, mydata);
	}
	else{
		if (! (typeof destinazioniBooking[idStart] === 'undefined')){
			// var AllDestinazioni = jQuery.parseJSON(destinazioniBooking);
			var myDestinazioni = destinazioniBooking[idStart];//("["+destinazioniBooking[idStart]+"]");

			var myObj = jQuery(".searchticket-fom [name=end]");
			myObj.html("");
			jQuery.each(myDestinazioni, function (idx, obj) {
				//console.log(obj.SettlementID+" "+obj.SettlementName);
				myObj.append('<option value="' + obj.SettlementID + '">' + obj.SettlementName + ' (' + obj.SettlementDescription + ')' + '</option>');
			});
		}
	}
}

function clv_getDestinazioni_prenotazione(idStart, specialMode) {
	//NOTA: il file ashx da caricare, lo parametriziamo per gestire anche le chiamate per le altre funzioni, come login, etc... che usano altri ashx
	if (idStart == "") return;
	if (specialMode == "") return;
	var url = urlTicketing + gaspariURL.ASHX_BOOKING;//nota: urlTicketing definita globalmente in JS
	var mode = 'getDestinazioni_prenotazione';
	var mydata = "{" +"mode: '" + mode + "'";
	mydata += ", id:'"+ idStart + "'";
	mydata += ", specialMode:'"+ specialMode + "'" + "}";
	var action = "clv_getUrlResponse";
	clv_ajax_call(mode, url, mydata);
}

//chiamato SOLO in caso di caricamento destinazioni con chiamata remota
function clv_callback_getDestinazioni(res){
	var dest = res.data[0].destinazioni;
	destinazioniBooking = res.data[0].destinazioni;
	
	var myObj = jQuery(".searchticket-fom [name=end]");
	myObj.html("");
	for(var i =0; i<dest.length; i++){
		myObj.append(jQuery("<option></option>").val(dest[i].SettlementID).html(dest[i].SettlementName + ' (' + dest[i].SettlementDescription + ')'));
	}
	if (!isMobile){
		jQuery(".searchticket-fom [name=end]").prop( "disabled", false );
		setTimeout("jQuery('[name=start]').prop( 'disabled', false );",3000);
	}	
}

//chiamato SOLO in caso di caricamento destinazioni con chiamata remota
function clv_callback_getDestinazioni_prenotazione(res){
	var dest = res.data[0].destinazioni;
	destinazioniBooking = res.data[0].destinazioni;
	
	var myObj = jQuery(".reservation-form [name=end]");
	myObj.html("");
	for(var i =0; i<dest.length; i++){
		myObj.append(jQuery("<option></option>").val(dest[i].SettlementID).html(dest[i].SettlementName + ' (' + dest[i].SettlementDescription + ')'));
	}
	if (!isMobile){
		jQuery(".reservation-form [name=end]").prop( "disabled", false );
		setTimeout("jQuery('.reservation-form [name=start]').prop( 'disabled', false );",3000);
	}	
}
var utenteAzioneAdminUser = null;
function clv_adminUser(action, id) {
	var url = urlTicketing + gaspariURL.ASHX_UTENTI;//nota: urlTicketing definita globalmente in JS

	switch(action) {
		case 'lock':
			var mode = 'lockUser';
			break;
		case 'unlock':
			var mode = 'unlockUser';
			break;
		case 'delete':
			var mode = 'delete_full_asp_user';
			break;
		default:
			break;
	}
	utenteAzioneAdminUser = id;
	var mydata = "{" +"mode: '" + mode + "'";
	mydata += ", userId:'"+ id + "'" + "}";
	var action = "clv_getUrlResponse";
	clv_ajax_call(mode, url, mydata);
}


function clv_callback_lockUser(res){
	console.log(res.data);
	if(res.response == "ok"){
		//cambiamo la action e l'icona del link lock user in unlock
		var el = jQuery("#locking-"+utenteAzioneAdminUser);
		el.attr("href", "?action=unlock&id="+utenteAzioneAdminUser);
		el.html('<i class="fa fa-lock" aria-hidden="true" >');
	}
	utenteAzioneAdminUser = null;
	clv_alertMsg2(res.data);
}
function clv_callback_unlockUser(res){
	console.log(res.data);
	if(res.response == "ok"){
		//cambiamo la action e l'icona del link lock user in unlock
		var el = jQuery("#locking-"+utenteAzioneAdminUser);
		el.attr("href", "?action=lock&id="+utenteAzioneAdminUser);
		el.html('<i class="fa fa-unlock" aria-hidden="true" >');
	}
	utenteAzioneAdminUser = null;
	clv_alertMsg2(res.data);
}
function clv_callback_delete_full_asp_user(res){
	console.log(res.data);
	if(res.response == "ok"){
		//eliminiamo la riga
		var el = jQuery("#riga-"+utenteAzioneAdminUser);
		el.remove();
	}
	utenteAzioneAdminUser = null;
	clv_alertMsg2(res.data);
}

function clv_presetOrder() {
  var url = urlTicketing + gaspariURL.ASHX_BOOKING;//nota: urlTicketing definita globalmente in JS
  var mode = 'preset-order-update';
  var mydata = "{" +"mode:'" + mode + "'";

  mydata += ",id-presets-list:'"+ presetArray.join(",") + "'" + "}";
  var action = "clv_getUrlResponse";
  clv_ajax_call(mode, url, mydata);
}

function clv_callback_preset_order_update(res) {
	clv_showAlert(res.data,"alert-success");
	jQuery('#preset-order-update').addClass('disabled');
}

/*
 *  Bootstrap Alerts -
 *  Function Name - clv_showAlert()
 *  Inputs - message,alerttype
 *  Example - clv_showAlert("Invalid Login","alert-danger")
 *  Types of alerts: "alert-success","alert-info","alert-warning", "alert-danger"
 *  Required - You only need to add a alert_placeholder div in your html page wherever you want to display these alerts "<div id="alert_placeholder"></div>"
 *
 */

  function clv_showAlert(message,alerttype) {
  	var closeButton = '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
  	var alertHTML = '<div class="alert ' +  alerttype + ' alert-dismissible fade in" role="alert">'+ closeButton + message +'</div>';

    var alert = jQuery(alertHTML).appendTo('#alert_placeholder');
    setTimeout(function() { // this will automatically close the alert and remove this if the users doesnt close it in 5 secs
    	jQuery(alert).alert('close');
	}, 10000);
  }

/*
 * printThis v1.5
 * @desc Printing plug-in for jQuery
 * @author Jason Day
 *
 * Resources (based on) :
 *              jPrintArea: http://plugins.jquery.com/project/jPrintArea
 *              jqPrint: https://github.com/permanenttourist/jquery.jqprint
 *              Ben Nadal: http://www.bennadel.com/blog/1591-Ask-Ben-Print-Part-Of-A-Web-Page-With-jQuery.htm
 *
 * Licensed under the MIT licence:
 *              http://www.opensource.org/licenses/mit-license.php
 *
 * (c) Jason Day 2015
 *
 * Usage:
 *
 *  $("#mySelector").printThis({
 *      debug: false,               * show the iframe for debugging
 *      importCSS: true,            * import page CSS
 *      importStyle: false,         * import style tags
 *      printContainer: true,       * grab outer container as well as the contents of the selector
 *      loadCSS: "path/to/my.css",  * path to additional css file - us an array [] for multiple
 *      pageTitle: "",              * add title to print page
 *      removeInline: false,        * remove all inline styles from print elements
 *      printDelay: 333,            * variable print delay
 *      header: null,               * prefix to html
 *      formValues: true            * preserve input/form values
 *  });
 *
 * Notes:
 *  - the loadCSS will load additional css (with or without @media print) into the iframe, adjusting layout
 */
;
(function($) {
    var opt;
    $.fn.printThis = function(options) {
        opt = $.extend({}, $.fn.printThis.defaults, options);
        var $element = this instanceof jQuery ? this : $(this);

        var strFrameName = "printThis-" + (new Date()).getTime();

        if (window.location.hostname !== document.domain && navigator.userAgent.match(/msie/i)) {
            // Ugly IE hacks due to IE not inheriting document.domain from parent
            // checks if document.domain is set by comparing the host name against document.domain
            var iframeSrc = "javascript:document.write(\"<head><script>document.domain=\\\"" + document.domain + "\\\";</script></head><body></body>\")";
            var printI = document.createElement('iframe');
            printI.name = "printIframe";
            printI.id = strFrameName;
            printI.className = "MSIE";
            document.body.appendChild(printI);
            printI.src = iframeSrc;

        } else {
            // other browsers inherit document.domain, and IE works if document.domain is not explicitly set
            var $frame = $("<iframe id='" + strFrameName + "' name='printIframe' />");
            $frame.appendTo("body");
        }


        var $iframe = $("#" + strFrameName);

        // show frame if in debug mode
        if (!opt.debug) $iframe.css({
            position: "absolute",
            width: "0px",
            height: "0px",
            left: "-600px",
            top: "-600px"
        });


        // $iframe.ready() and $iframe.load were inconsistent between browsers    
        setTimeout(function() {

            // Add doctype to fix the style difference between printing and render
            function setDocType($iframe,doctype){
                var win, doc;
                win = $iframe.get(0);
                win = win.contentWindow || win.contentDocument || win;
                doc = win.document || win.contentDocument || win;
                doc.open();
                doc.write(doctype);
                doc.close();
            }
            if(opt.doctypeString){
                setDocType($iframe,opt.doctypeString);
            }

            var $doc = $iframe.contents(),
                $head = $doc.find("head"),
                $body = $doc.find("body");

            // add base tag to ensure elements use the parent domain
            $head.append('<base href="' + document.location.protocol + '//' + document.location.host + '">');

            // import page stylesheets
            if (opt.importCSS) $("link[rel=stylesheet]").each(function() {
                var href = $(this).attr("href");
                if (href) {
                    var media = $(this).attr("media") || "all";
                    $head.append("<link type='text/css' rel='stylesheet' href='" + href + "' media='" + media + "'>")
                }
            });
            
            // import style tags
            if (opt.importStyle) $("style").each(function() {
                $(this).clone().appendTo($head);
                //$head.append($(this));
            });

            //add title of the page
            if (opt.pageTitle) $head.append("<title>" + opt.pageTitle + "</title>");

            // import additional stylesheet(s)
            if (opt.loadCSS) {
               if( $.isArray(opt.loadCSS)) {
                    jQuery.each(opt.loadCSS, function(index, value) {
                       $head.append("<link type='text/css' rel='stylesheet' href='" + this + "'>");
                    });
                } else {
                    $head.append("<link type='text/css' rel='stylesheet' href='" + opt.loadCSS + "'>");
                }
            }

            // print header
            if (opt.header) $body.append(opt.header);

            // grab $.selector as container
            if (opt.printContainer) $body.append($element.outer());

            // otherwise just print interior elements of container
            else $element.each(function() {
                $body.append($(this).html());
            });

            // capture form/field values
            if (opt.formValues) {
                // loop through inputs
                var $input = $element.find('input');
                if ($input.length) {
                    $input.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $checker = $this.is(':checkbox') || $this.is(':radio'),
                            $iframeInput = $doc.find('input[name="' + $name + '"]'),
                            $value = $this.val();

                        //order matters here
                        if (!$checker) {
                            $iframeInput.val($value);
                        } else if ($this.is(':checked')) {
                            if ($this.is(':checkbox')) {
                                $iframeInput.attr('checked', 'checked');
                            } else if ($this.is(':radio')) {
                                $doc.find('input[name="' + $name + '"][value=' + $value + ']').attr('checked', 'checked');
                            }
                        }

                    });
                }

                //loop through selects
                var $select = $element.find('select');
                if ($select.length) {
                    $select.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('select[name="' + $name + '"]').val($value);
                    });
                }

                //loop through textareas
                var $textarea = $element.find('textarea');
                if ($textarea.length) {
                    $textarea.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('textarea[name="' + $name + '"]').val($value);
                    });
                }
            } // end capture form/field values

            // remove inline styles
            if (opt.removeInline) {
                // $.removeAttr available jQuery 1.7+
                if ($.isFunction($.removeAttr)) {
                    $doc.find("body *").removeAttr("style");
                } else {
                    $doc.find("body *").attr("style", "");
                }
            }

            setTimeout(function() {
                if ($iframe.hasClass("MSIE")) {
                    // check if the iframe was created with the ugly hack
                    // and perform another ugly hack out of neccessity
                    window.frames["printIframe"].focus();
                    $head.append("<script>  window.print(); </script>");
                } else {
                    // proper method
                    if (document.queryCommandSupported("print")) {
                        $iframe[0].contentWindow.document.execCommand("print", false, null);
                    } else {
                        $iframe[0].contentWindow.focus();
                        $iframe[0].contentWindow.print();
                    }
                }

                //remove iframe after print
                if (!opt.debug) {
                    setTimeout(function() {
                        $iframe.remove();
                    }, 1000);
                }

            }, opt.printDelay);

        }, 333);

    };

    // defaults
    $.fn.printThis.defaults = {
        debug: false,           // show the iframe for debugging
        importCSS: true,        // import parent page css
        importStyle: false,     // import style tags
        printContainer: true,   // print outer container/$.selector
        loadCSS: "",            // load an additional css file - load multiple stylesheets with an array []
        pageTitle: "",          // add title to print page
        removeInline: false,    // remove all inline styles
        printDelay: 333,        // variable print delay
        header: null,           // prefix to html
        formValues: true,        // preserve input/form values
        doctypeString: '<!DOCTYPE html>' // html doctype
    };

    // $.selector container
    jQuery.fn.outer = function() {
        return $($("<div></div>").html(this.clone())).html()
    }
})(jQuery);


function clv_showUtilsLogin(mode,label){
	if(mode!="resetPassword" && mode != "reinoltraAuthCode"){
		return;	
	}
	jQuery("#btn_submitUserTools").text(label);
	jQuery("#utilsModalLabel").text(label);
	
	jQuery("#btn_submitUserTools").click(function(e){
		clv_utilsLogin(mode);
	});
	if ((jQuery("#modalLogin").data('bs.modal') || {}).isShown){
		jQuery("#modalLogin").modal("hide").delay(500).queue(function(){
			jQuery("#modalTools").modal("show");
			jQuery( this ).dequeue();
		});
	}
	else jQuery("#modalTools").modal("show");
}

function clv_utilsLogin(mode) {
	if(mode!="resetPassword" && mode != "reinoltraAuthCode"){
		return;	
	}
	var email = jQuery("#modal-tools-form input[name='username']").first().val();
	
	if (email == "") return;
	// if (typeof(destinazioniBooking) === 'undefined'){
	var url = urlTicketing + gaspariURL.ASHX_UTENTI;//nota: urlTicketing definita globalmente in JS
	//var mode = 'getDestinazioni';
	var mydata = "{" +"mode: '" + mode + "'";
	
	mydata += ", email:'"+ email + "'" + "}";
	var action = "clv_getUrlResponse";
	console.log(mydata);
	showPleaseWait();
	clv_ajax_call(mode, url, mydata);	
}
//chiamato SOLO in caso di caricamento destinazioni con chiamata remota
function clv_callback_resetPassword(res){
	//var dest = res.data[0].response;
	console.log(res.data);
	hidePleaseWait();
	clv_alertMsg2(res.data);
}
//chiamato SOLO in caso di caricamento destinazioni con chiamata remota
function clv_callback_reinoltraAuthCode(res){
	//var dest = res.data[0].response;
	console.log(res.data);
	hidePleaseWait();
	clv_alertMsg2(res.data);
}

function gaspariRestApiCall( mydata, ajaxurl ){
	// Assegno AjaxURL in modo che sia possibile comprimere il file tramite gulp
	ajaxurl = (typeof ajaxurl == 'undefined' ? gaspariURL.WP_REST_URL + 'gaspari-api/v1/subscriptioninfo/' : ajaxurl);

	jQuery.post( ajaxurl, { 'data':mydata  }, function(response){
		console.log(response)
		try { console.log(response) } 
		catch(e) { console.log(e) };
	});
}